const EnlacesDirectosHome = ({
  title,
  principalDirectLink,
  secundaryDirectLink,
  collapsePanelDirectLinks,
  index,
  panelStyle,
  open
}) => {
  return (
    <div>
      {(secundaryDirectLink > 0 || principalDirectLink) && open === false ? (
        <div
          className='row contain-card'
          style={
            secundaryDirectLink != 0 || principalDirectLink != 0
              ? panelStyle
              : null
          }
        >
          <div>
            {secundaryDirectLink != 0 || principalDirectLink != 0 ? (
              <h2>{title}</h2>
            ) : null}
          </div>
          <div className='principal-contain-card col-xs-12 col-md-12'>
            {principalDirectLink.map(item => {
              return (
                <div className='col-xs-12 col-sm-3 col-md-3 card'>
                  <h3>{item["Titulo"]}</h3>
                  <a href={item["Link"]}>
                    <div className='imageBox'>
                      <img src={item["IconoServicioUrl"]} />
                    </div>
                  </a>
                  <button
                    onClick={() => (window.location.href = item["Link"])}
                    type='button'
                    className='btn btn-block btn-primary'
                  >
                    {item["BotonServicio"]}
                  </button>
                  <div className='separatorButtonCard' />
                </div>
              );
            })}
            {secundaryDirectLink.length > 0 && open === false ? (
              <div
                className='col-xs-12 col-sm-3 col-md-3 card'
                onClick={() => collapsePanelDirectLinks(index, true)}
              >
                <div className='showMoreBackground'>
                  <h3>Más Servicios</h3>
                  <div className='circle-gray'>
                    {open === false ? (
                      <i className='fa fa-plus' />
                    ) : (
                      <i className='fa fa-minus' />
                    )}
                  </div>
                  <button
                    onClick={() => collapsePanelDirectLinks(index, true)}
                    type='button'
                    className='btn btn-block btn-primary'
                  >
                    {open === false ? "Ver Más" : "Ver Menos"}
                  </button>
                  <div className='separatorButtonCard' />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div
          className='row contain-card'
          style={
            secundaryDirectLink != 0 || principalDirectLink != 0
              ? panelStyle
              : null
          }
        >
          <div>
            {secundaryDirectLink != 0 || principalDirectLink != 0 ? (
              <h2>{title}</h2>
            ) : null}
          </div>
          <Panel id='collapsible-panel-example-1' expanded={open}>
            <Panel.Collapse>
              <div className='secundary-contain-card col-xs-12 col-md-12'>
                {secundaryDirectLink.map(item => {
                  return (
                    <div className='col-xs-12 col-sm-3 col-md-3 card'>
                      <h3>{item["Titulo"]}</h3>
                      <a href={item["Link"]}>
                        <div className='imageBox'>
                          <img src={item["IconoServicioUrl"]} />
                        </div>
                      </a>
                      <button
                        onClick={() => (window.location.href = item["Link"])}
                        type='button'
                        className='btn btn-block btn-primary'
                      >
                        {item["BotonServicio"]}
                      </button>
                      <div className='separatorButtonCard' />
                    </div>
                  );
                })}
                {principalDirectLink.length > 2 &&
                secundaryDirectLink.length > 0 &&
                open === true ? (
                  <div
                    className='col-xs-12 col-sm-3 col-md-3 card'
                    onClick={() => collapsePanelDirectLinks(index, false)}
                  >
                    <div className='showMoreBackgroundOpen'>
                      <h3>Más Servicios</h3>
                      <div className='circle-gray'>
                        {open === true ? (
                          <i className='fa fa-minus' />
                        ) : (
                          <i className='fa fa-plus' />
                        )}
                      </div>
                      <button
                        onClick={() => collapsePanelDirectLinks(index, false)}
                        type='button'
                        className='btn btn-block btn-primary'
                      >
                        {open === true ? "Ver Menos" : "Ver Más"}
                      </button>
                      <div className='separatorButtonCard' />
                    </div>
                  </div>
                ) : null}
              </div>
            </Panel.Collapse>
          </Panel>
        </div>
      )}
    </div>
  );
};

const Button = ReactBootstrap.Button;
const Panel = ReactBootstrap.Panel;

export default EnlacesDirectosHome;



// WEBPACK FOOTER //
// ./newHome/src/components/enlacesDirectosHome.js